"use client";

import { createContext, useState } from "react";

interface MessageContextType {
  message: {
    isOpen: boolean;
    content: string;
    severity?: "info" | "success" | "warning" | "error";
  };
  setMessage: React.Dispatch<React.SetStateAction<{ isOpen: boolean; content: string, severity?: "info" | "success" | "warning" | "error" }>>;
}

const MessageContext = createContext<MessageContextType | undefined>(undefined);

export const MessageProvider = ({ children }) => {
  const [message, setMessage] = useState<{
    isOpen: boolean;
    content: string;
    severity?: "info" | "success" | "warning" | "error";
  }>({
    isOpen: false,
    content: "",
    severity: "info"
  });

  return (
    <MessageContext.Provider value={{ message, setMessage }}>
      {children}
    </MessageContext.Provider>
  );
};

export default MessageContext;
